<template functional>
  <div class="policy-contents">
    <div class="policy">
      <h3 class="policy__title">Müşteri Aydınlatma Metni</h3>
      <div class="policy__content">
        <div class="page-title">
          Kişisel Verilerin Korunması Mevzuatı Uyarınca <br />
          Müşterilere İlişkin Aydınlatma Metni
        </div>
        <div class="entrance-text">
          Değerli müşterimiz, <br />
          Vivense Teknoloji Hizmetleri ve Ticaret Anonim Şirketi (<b
            >“Vivense”</b
          >
          veya <b>“Şirket”</b>) olarak, veri sorumlusu sıfatıyla,
          <ul class="discover-list">
            <li>
              <b>Sitemizde üye olmaktaysanız</b> üyelik hizmetlerimizden
              yararlanabilmeniz için,
            </li>
            <li>
              <b
                >İnternet sitemiz üzerinden sipariş veren bir
                müşterimizseniz;</b
              >
              internet sitemizden yaptığınız alışveriş kapsamında hizmetlerimizi
              sizlere sunabilmemiz için,
            </li>
            <li>
              <b>Mağazalarımızdan alışveriş yapan bir müşterimizseniz;</b>
              mağazalarımızdaki ziyaretinizde yapacağınız alışverişiniz
              sırasında,
            </li>
          </ul>

          sizlerden elde ettiğimiz kişisel verileri Kişisel Verileri Koruma
          Kanun (“KVKK”) tahtında belirtilen ve aşağıda detayları açıklanan
          amaçlar çerçevesinde, bu amaçlar ile bağlantılı, sınırlı ve ölçülü
          şekilde kişisel verilerin doğruluğunu ve en güncel halini koruyarak
          kaydedeceğimizi, depolayacağımızı, muhafaza edeceğimizi ve kanunen
          kişisel verileri talep etmeye yetkili olan kurumlar ile
          paylaşacağımızı KVKK’nın öngördüğü şartlarda üçüncü kişilere ve
          şirketlere aktaracağımızı bilgilerinize sunuyoruz.
        </div>
        <div class="sub-title">
          1. KVKK’ya İlişkin Tanımlamalar
        </div>
        <div class="entrance-text">
          KVKK’nın uygulanmasında;
          <ul class="discover-list">
            <li>
              <u>Anonim hâle getirme</u>: Kişisel verilerin, başka verilerle
              eşleştirilerek dahi hiçbir surette kimliği belirli veya
              belirlenebilir bir gerçek kişiyle ilişkilendirilemeyecek hâle
              getirilmesini,
            </li>
            <li><u>İlgili Kişi:</u> Kişisel verisi işlenen gerçek kişiyi,</li>
            <li>
              <u>Kişisel veri:</u> Kimliği belirli veya belirlenebilir gerçek
              kişiye ilişkin her türlü bilgiyi,
            </li>
            <li>
              <u>Kişisel verilerin işlenmesi:</u> Kişisel verilerin tamamen veya
              kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin
              parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi,
              kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi,
              yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde
              edilebilir hâle getirilmesi, sınıflandırılması ya da
              kullanılmasının engellenmesi gibi veriler üzerinde
              gerçekleştirilen her türlü işlemi,
            </li>
            <li><u>Kurul:</u> Kişisel Verileri Koruma Kurulunu,</li>
            <li><u>Kurum:</u> Kişisel Verileri Koruma Kurumunu,</li>
            <li>
              <u>Veri işleyen:</u> Veri sorumlusunun verdiği yetkiye dayanarak
              onun adına kişisel verileri işleyen gerçek veya tüzel kişiyi,
            </li>
            <li>
              <u>Veri kayıt sistemi:</u> Kişisel verilerin belirli kriterlere
              göre yapılandırılarak işlendiği kayıt sistemini,
            </li>
            <li>
              <u>Veri sorumlusu:</u> Kişisel verilerin işleme amaçlarını ve
              vasıtalarını belirleyen, veri kayıt sisteminin kurulmasından ve
              yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi,
            </li>
            <li>
              <u>Özel nitelikli kişisel veri:</u> Kişilerin ırkı, etnik kökeni,
              siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer
              inançları, kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği,
              sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik tedbirleriyle
              ilgili verileri ile biyometrik ve genetik verilerini, ifade eder.
            </li>
          </ul>
        </div>
        <div class="sub-title">
          2. Kişisel Veri Nedir? Hangi Kişisel Veriler İşlenmektedir?
        </div>
        <div class="entrance-text">
          Kişisel veri, kimliğinizi belirleyen veya belirlenebilir kılan her
          türlü bilgidir. Bu kapsamda başlıca kimlik bilgileriniz olan adınız
          soyadınız, T.C. kimlik numaranız olmak üzere, adres ve telefon
          bilgileriniz, banka hesap bilgileriniz gibi sizinle
          ilişkilendirilebilir her türlü bilgi “Kişisel Veri” olarak ifade
          edilmektedir. KVKK madde 6 uyarınca düzenlenen ırk, etnik köken,
          siyasi düşünce, felsefi inanç, din, mezhep veya diğer inançları,
          dernek, vakıf veya sendika üyeliği, sağlık, cinsel hayat, ceza
          mahkumiyeti ve güvenlik tedbirleriyle ilgili verileriniz ile
          biyometrik ve genetik verileriniz gibi hassas nitelikli veriler ise
          “Özel Nitelikli Kişisel Veri” olarak ifade edilmektedir. Vivense işbu
          aydınlatma metninde değinilen veri işleme faaliyetleri kapsamında
          herhangi bir özel nitelikli kişisel verinizi işlememektedir.
        </div>
        <div class="sub-title">
          3. İşlenebilecek Kişisel Verileri, Veri İşleme Amacı ve Hukuki
          Sebepleri
        </div>
        <div class="entrance-text">
          Bu kapsamda Vivense olarak KVKK’ya uygun olarak aşağıda belirttiğimiz
          Kişisel Verileri toplayarak muhafaza etmekteyiz.

          <br />
          <div style="margin: 20px 0 10px 10px; color: #333333;">
            <b
              >3.1 İnternet sitemize üye olmaktaysanız aşağıdaki kişisel
              verilerinizi işlemekteyiz;</b
            >
          </div>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Kimlik Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ad-Soyad</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Bilgi güvenliği süreçlerinin yürütülmesi, <br />
                  Teklif oluşturma hizmetimizin tarafınıza sunulması, <br />
                  Sözleşme süreçlerinin yönetilmesi, <br />
                  Veri sorumlusu operasyonlarının güvenliğinin temini, işlem
                  yapanın / yaptıranın kimlik tespitinin yapılması.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Üye kaydınızın yapılması ve buradaki hizmetlerin ifasıyla
                  doğrudan doğruya ilgili olması kaydıyla tarafınıza ait kişisel
                  verilerin işlenmesinin gerekli olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>İletişim Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>E-posta, Telefon numarası, Adres Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Firma/ürün/hizmetlere bağlılık süreçlerinin yürütülmesi,
                  <br />
                  İletişim faaliyetlerinin yürütülmesi, <br />
                  Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                  <br />
                  Talep / şikâyetlerin takibi, <br />
                  Bilgi güvenliği süreçlerinin yürütülmesi, <br />
                  Mal / hizmet satış sonrası destek hizmetlerinin yürütülmesi,
                  <br />
                  Mal / hizmet satış sözleşmelerinin yürütülmesi, <br />
                  Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Üye kaydınızın yapılması ve buradaki hizmetlerin ifasıyla
                  doğrudan doğruya ilgili olması kaydıyla tarafınıza ait kişisel
                  verilerin işlenmesinin gerekli olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  İletişim Bilgisi* <br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde iletişim verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>E-posta, Telefon numarası</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Firma/ürün/hizmetlere bağlılık süreçlerinin yürütülmesi,
                  <br />
                  Organizasyon ve etkinlik yönetimi, pazarlama analiz
                  çalışmalarının yönetilmesi, <br />
                  kampanya/promosyon süreçlerinin yönetilmesi,<br />
                  Ürün / hizmetlerin pazarlama süreçlerinin yürütülmesi.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Kampanya ve daha uygun başka teklif seçeneklerinden haberdar
                  olmak istemeniz halinde iletişim veriniz açık rızanızın
                  varlığı halinde işlenecektir.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Müşteri İşlem Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>İlgilendiğiniz ürünler ve hizmet geçmişi bilginiz</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                  <br />
                  Ürün / hizmetlerin pazarlama süreçlerinin yürütülmesi,
                  <br />
                  Mal / hizmet satış sonrası destek hizmetlerinin yürütülmesi,
                  <br />
                  Talep / şikâyetlerin takibi, <br />
                  Mal / hizmet satış sözleşmelerinin yürütülmesi, <br />
                  Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Üyelik hizmetlerinin ifasıyla doğrudan doğruya ilgili olması
                  kaydıyla tarafınıza ait kişisel verilerin işlenmesinin gerekli
                  olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>İşlem Güvenliği Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>
                  IP adresi bilgileri, internet sitesi giriş çıkış bilgileri,
                  şifre ve parola bilgileriniz vb.
                </td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Bilgi güvenliği süreçlerinin yürütülmesi, <br />
                  Faaliyetlerin mevzuata uygun yürütülmesi, <br />
                  İş faaliyetlerinin yürütülmesi / denetimi, <br />
                  Veri sorumlusu operasyonlarının güvenliğinin temini.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Üye kaydınızın yapılması ve buradaki hizmetlerin ifasıyla
                  doğrudan doğruya ilgili olması kaydıyla tarafınıza ait kişisel
                  verilerin işlenmesinin gerekli olması, ve Veri sorumlusunun
                  yasal yükümlülüklerini yerine getirmesi
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div style="margin: 0 0 10px 10px; color: #333333;">
            <b
              >3.1.1 Vivense İçMimarGPT Kullanımı Gerçekleştiren Üyemiz Olmanız
              Halinde;</b
            >
          </div>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Görsel ve İşitsel Kayıtlar</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Fotoğraf (Oda Görseli)</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,<br />
                  Ürün / hizmetlerin pazarlama süreçlerinin yürütülmesi,
                  <br />
                  Talep / şikâyetlerin takibi,<br />
                  Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,<br />
                  Diğer (Sosyal medyada tanıtım faaliyetlerinin yürütülmesi)*
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  İlgili kişinin kendisi tarafından alenileştirilmiş olması.<br /><br />
                  *Tanıtım faaliyeti kapsamında yüklediğiniz fotoğrafın
                  kullanılması ve bu kapsamda sosyal medya hesaplarımızda veya
                  sosyal medya platformlarında yer verilecek tanıtıcı reklam
                  faaliyetleri sırasında paylaşım yapılması ancak açık rızanızın
                  varlığında meydana gelebilir.
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div style="margin: 0 0 10px 10px; color: #333333;">
            <b
              >3.2 İnternet sitemiz üzerinden sipariş veren müşterimizseniz
              aşağıdaki kişisel verilerinizi işlemekteyiz:</b
            >
          </div>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Kimlik Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ad-Soyadı, T.C. Kimlik Numarası</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>
                  <ul>
                    <b>Müşteri Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma, ürün ve hizmetlere bağlılık süreçlerinin
                      yürütülmesi,
                    </li>
                    <li>
                      - İş süreçlerinin iyileştirilmesine yönelik önerilerin
                      alınması ve değerlendirilmesi,
                    </li>
                    <li>- Mal ve hizmet satışı süreçlerinin yürütülmesi,</li>
                    <li>
                      - Mal ve hizmet satışı sonrası destek hizmetlerinin
                      yürütülmesi,
                    </li>
                    <li>- Sözleşme süreçlerinin yürütülmesi,</li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>- Talep ve şikayetlerin takibi.</li>
                  </ul>
                  <ul>
                    <b>Adli Süreçlerin Söz konusu Olması Halinde;</b>
                    <li>- Hukuk işlerinin takibi ve yürütülmesi,</li>
                    <li>- Talep / Şikayetlerin Yönetimi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması.

                  <br />Veri sorumlusunun hukuki yükümlülüğünü yerine
                  getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Kimlik Bilgisi*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde kimlik verinizi işleyebilmekteyiz.
                  </i>
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ad-Soyadı, Kullanıcı Adınız</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve Görsel Kayıtlarınızın Pazarlama Faaliyetleri
                      için Kullanılabilmesi.
                    </li>
                  </ul>

                  <ul>
                    <b
                      >Tarafınıza Reklam, Kampanya, Pazarlama Bildirimlerinin
                      Yapılabilmesi için;</b
                    >
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>İletişim Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Telefon Numarası, E-posta Adresi, Adres Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>

                  <ul>
                    <b
                      >Müşterilere Talep Etmiş Olduğu Hizmetlerin Sunulması
                      için;</b
                    >
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme süreçlerinin yürütülmesi.</li>
                  </ul>

                  <ul>
                    <b>Müşteri Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin
                      Alınması ve Değerlendirilmesi,
                    </li>
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Talep / Şikayetlerin Takibi.</li>
                  </ul>

                  <ul>
                    <b>Adli Süreçlerin Söz konusu Olması Halinde;</b>
                    <li>- Hukuk işlerinin takibi ve yürütülmesi,</li>
                    <li>- Talep / Şikayetlerin Yönetimi</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. Veri sorumlusunun
                  hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  İletişim Bilgisi*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde iletişim verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Telefon Numarası, E-posta Adresi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve Görsel Kayıtlarınızın Pazarlama Faaliyetleri
                      için Kullanılabilmesi.
                    </li>
                  </ul>

                  <ul>
                    <b
                      >Tarafınıza Reklam, Kampanya, Pazarlama Bildirimlerinin
                      Yapılabilmesi için;</b
                    >
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Müşteri İşlem Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>
                  Sipariş Bilgisi, Satın Alınan Ürün Bilgisi, Yazılı Görüşme
                  Kayıtları
                </td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>
                  <ul>
                    <b>Müşteri Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin
                      Alınması ve Değerlendirilmesi,
                    </li>
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Talep / Şikayetlerin Takibi.</li>
                  </ul>

                  <ul>
                    Adli Süreçlerin Söz konusu Olması Halinde;
                    <li>Hukuk işlerinin takibi ve yürütülmesi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. Veri sorumlusunun
                  hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Hukuki İşlem Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Müşteri Dilekçeleri</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>Hukuk işlerinin takibi ve yürütülmesi.</td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi
                  için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Pazarlama*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde pazarlama verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Alışveriş Geçmişi Bilgileri, Anket Verisi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b>Müşteri memnuniyetini iyileştirmek için;</b>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Pazarlama Analiz Çalışmalarının Yürütülmesi,</li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Görsel ve İşitsel Kayıtlar</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ses Kaydı</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşteri Şikâyet ve Talebi Olması Halinde Yapılan
                      Görüşmelerin Kayıt Altına Alınması Sebebiyle;</b
                    >
                    <li>
                      - Firma, ürün ve hizmetlere bağlılık süreçlerinin
                      yürütülmesi,
                    </li>
                    <li>
                      - İş süreçlerinin iyileştirilmesine yönelik önerilerin
                      alınması ve değerlendirilmesi,
                    </li>
                    <li>- Mal ve hizmet satışı süreçlerinin yürütülmesi,</li>
                    <li>
                      - Mal ve hizmet satışı sonrası destek hizmetlerinin
                      yürütülmesi,
                    </li>
                    <li>- Sözleşme süreçlerinin yürütülmesi,</li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>- Talep ve şikayetlerin takibi,</li>
                    <li>- Bilgi güvenliği süreçlerinin yürütülmesi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. İlgili kişinin temel
                  hak ve özgürlüklerine zarar vermemek kaydıyla, veri
                  sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu
                  olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Görsel ve İşitsel Kayıtlar*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde görsel ve işitsel kayıtlar verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Görsel Kayıt</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam, kampanya ve promosyon süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve görsel kayıtlarınızın sosyal medya
                      hesaplarımızda paylaşılması.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>İşlem Güvenliği Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Log Kayıtları</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Bilgi güvenliği süreçlerinin yürütülmesi.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi
                  için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>

          <br />
          <div style="margin: 0 0 10px 10px; color: #333333;">
            <b
              >3.3 Mağazalarımızdan alışveriş yapan bir müşterimizseniz
              aşağıdaki kişisel verilerinizi işlemekteyiz;</b
            >
          </div>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Kimlik Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ad-Soyadı, T.C. Kimlik Numarası</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>
                  <ul>
                    <b>Müşteri Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma, ürün ve hizmetlere bağlılık süreçlerinin
                      yürütülmesi,
                    </li>
                    <li>
                      - İş süreçlerinin iyileştirilmesine yönelik önerilerin
                      alınması ve değerlendirilmesi,
                    </li>
                    <li>- Mal ve hizmet satışı süreçlerinin yürütülmesi,</li>
                    <li>
                      - Mal ve hizmet satışı sonrası destek hizmetlerinin
                      yürütülmesi,
                    </li>
                    <li>- Sözleşme süreçlerinin yürütülmesi,</li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>- Talep ve şikayetlerin takibi.</li>
                  </ul>
                  <ul>
                    <b>Adli Süreçlerin Söz konusu Olması Halinde;</b>
                    <li>- Hukuk işlerinin takibi ve yürütülmesi,</li>
                    <li>- Talep / Şikayetlerin Yönetimi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması.

                  <br />Veri sorumlusunun hukuki yükümlülüğünü yerine
                  getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Kimlik Bilgisi*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde kimlik verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ad-Soyadı, Kullanıcı Adınız</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve Görsel Kayıtlarınızın Pazarlama Faaliyetleri
                      için Kullanılabilmesi.
                    </li>
                  </ul>

                  <ul>
                    <b
                      >Tarafınıza Reklam, Kampanya, Pazarlama Bildirimlerinin
                      Yapılabilmesi için;</b
                    >
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>İletişim Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Telefon Numarası, E-posta Adresi, Adres Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>

                  <ul>
                    <b
                      >Müşterilere Talep Etmiş Olduğu Hizmetlerin Sunulması
                      için;</b
                    >
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme süreçlerinin yürütülmesi.</li>
                  </ul>

                  <ul>
                    <b>Müşteri Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin
                      Alınması ve Değerlendirilmesi,
                    </li>
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Talep / Şikayetlerin Takibi.</li>
                  </ul>

                  <ul>
                    <b>Adli Süreçlerin Söz konusu Olması Halinde;</b>
                    <li>- Hukuk işlerinin takibi ve yürütülmesi,</li>
                    <li>- Talep / Şikayetlerin Yönetimi</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. Veri sorumlusunun
                  hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  İletişim Bilgisi*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde iletişim verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Telefon Numarası, E-posta Adresi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve Görsel Kayıtlarınızın Pazarlama Faaliyetleri
                      için Kullanılabilmesi.
                    </li>
                  </ul>

                  <ul>
                    <b
                      >Tarafınıza Reklam, Kampanya, Pazarlama Bildirimlerinin
                      Yapılabilmesi için;</b
                    >
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Müşteri İşlem Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>
                  Sipariş Bilgisi, Satın Alınan Ürün Bilgisi, Yazılı Görüşme
                  Kayıtları
                </td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşterilerin Siparişlerinin Alınması ve Sipariş
                      Formlarının Oluşturulması için;</b
                    >
                    <li>- Mal / Hizmet Satış Süreçlerinin Yürütülmesi,</li>
                    <li>- Sözleşme Süreçlerinin Yürütülmesi,</li>
                    <li>- Saklama Ve Arşiv Faaliyetlerinin Yürütülmesi.</li>
                  </ul>
                  <ul>
                    <b>Müşteri'nin Şikâyet ve Talebi Olması Halinde;</b>
                    <li>
                      - Firma / Ürün / Hizmetlere Bağlılık Süreçlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin
                      Alınması ve Değerlendirilmesi,
                    </li>
                    <li>
                      - Mal / Hizmet Satış Sonrası Destek Hizmetlerinin
                      Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri İlişkileri Yönetimi Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Talep / Şikayetlerin Takibi.</li>
                  </ul>

                  <ul>
                    <b>Adli Süreçlerin Söz konusu Olması Halinde;</b>
                    <li>- Hukuk işlerinin takibi ve yürütülmesi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. Veri sorumlusunun
                  hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Hukuki İşlem Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Müşteri Dilekçeleri</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>Hukuk işlerinin takibi ve yürütülmesi.</td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi
                  için zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Pazarlama Bilgisi*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde pazarlama verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Alışveriş Geçmişi Bilgileri, Anket Verisi</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b>Müşteri memnuniyetini iyileştirmek için;</b>
                    <li>
                      - Müşteri Memnuniyetine Yönelik Aktivitelerin Yürütülmesi,
                    </li>
                    <li>- Pazarlama Analiz Çalışmalarının Yürütülmesi,</li>
                    <li>
                      - Ürün / Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi,
                    </li>
                    <li>
                      - Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Görsel ve İşitsel Kayıtlar</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Ses Kaydı</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Müşteri'nin Şikâyet ve Talebi Olması Halinde Yapılan
                      Görüşmelerin Kayıt Altına Alınması Sebebiyle;</b
                    >
                    <li>
                      - Firma, ürün ve hizmetlere bağlılık süreçlerinin
                      yürütülmesi,
                    </li>
                    <li>
                      - İş süreçlerinin iyileştirilmesine yönelik önerilerin
                      alınması ve değerlendirilmesi,
                    </li>
                    <li>- Mal ve hizmet satışı süreçlerinin yürütülmesi,</li>
                    <li>
                      - Mal ve hizmet satışı sonrası destek hizmetlerinin
                      yürütülmesi,
                    </li>
                    <li>- Sözleşme süreçlerinin yürütülmesi,</li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>- Talep ve şikayetlerin takibi,</li>
                    <li>- Bilgi güvenliği süreçlerinin yürütülmesi.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması. İlgili kişinin temel
                  hak ve özgürlüklerine zarar vermemek kaydıyla, veri
                  sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu
                  olması.
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>
                  Görsel ve İşitsel Kayıtlar*<br />
                  *<i
                    >Aşağıda detaylarını sunduğumuz amaçlar doğrultusunda açık
                    rızanızın olması halinde görsel ve işitsel kayıtlar verinizi
                    işleyebilmekteyiz.</i
                  >
                </td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Görsel Kayıt</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  <ul>
                    <b
                      >Sosyal Medya Hesabınızdaki Paylaşımların Kullanılabilmesi
                      için;</b
                    >
                    <li>
                      - Reklam, kampanya ve promosyon süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,
                    </li>
                    <li>
                      - Müşteri memnuniyetine yönelik aktivitelerin yürütülmesi,
                    </li>
                    <li>
                      - Yorum ve görsel kayıtlarınızın sosyal medya
                      hesaplarımızda paylaşılması.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>Açık rızanızın bulunması.</td>
              </tr>
            </tbody>
          </table>

          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <th>İşlenebilecek Veri Kategorisi</th>
                <td>Fiziksel Mekân Güvenliği Bilgisi</td>
              </tr>
              <tr>
                <th>İşlenebilecek Kişisel Veriler</th>
                <td>Görsel Kayıt</td>
              </tr>
              <tr>
                <th>İşlenme Amaçları</th>
                <td>
                  Mağazalarımızı ziyaretiniz sırasında fiziksel mekan
                  güvenliğinin sağlanabilmesi amacıyla 30 gün süre ile görsel
                  kaydınız işlenmektedir.
                </td>
              </tr>
              <tr>
                <th>İşlenme Hukuki Sebepleri</th>
                <td>
                  İlgili kişinin temel hak ve özgürlüklerine zarar vermemek
                  kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                  işlenmesinin zorunlu olması.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="sub-title">4. Kişisel Veri Toplama Yöntemi</div>
        <div class="entrance-text">
          Kişisel Verilerinizi, otomatik yahut otomatik olmayan yollarla, sesli,
          sözlü, yazılı veya elektronik şekilde işleyebilmekteyiz.
          <br />
          <b>İnternet sitemize üye olmaktaysanız;</b> Kişisel verilerinizi
          üyelik formunu doldurmanız suretiyle elektronik yollarla toplamakta,
          internet ve çeşitli sosyal medya mecralarında Vivense adına işletilen
          sosyal medya hesaplarımız üzerinden, e-posta, kısa mesajlar (“SMS”)
          veya multimedya mesajları (“MMS”) dahil sair iletişim yöntemleri
          kanalıyla, onay vermeniz halinde Vivense satış ve pazarlama
          faaliyetleri kapsamında veya ürün/hizmetin tarafınıza sağlanması için
          fatura, sözleşme gibi gerekli belgelerin şahsınızla düzenlenmesi veya
          müşteri memnuniyeti ve reklam ve pazarlama amaçlı faaliyetlerimizi
          gerçekleştirmemiz sırasında, talep-şikayet ve önerilerinizi
          tarafımızla paylaşmanız sırasında, sözlü, yazılı veya elektronik
          ortamda olmak üzere;<br />

          <b>Mağazalarımızdan alışveriş yapan bir müşterimizseniz; </b>
          Mağazamızı ziyaretiniz sırasında mağaza yetkililerimiz tarafından
          sipariş kaydınızın oluşturulması kaydıyla fiziksel ve elektronik
          formlar üzerinden sürecinizin yürütülmesi, onay vermeniz halinde
          Vivense satış ve pazarlama faaliyetleri kapsamında veya ürün/hizmetin
          tarafınıza sağlanması için fatura, sözleşme gibi gerekli belgelerin
          şahsınızla düzenlenmesi veya müşteri memnuniyeti ve reklam ve
          pazarlama amaçlı faaliyetlerimizi gerçekleştirmemiz sırasında,
          talep-şikayet ve önerilerinizi tarafımızla paylaşmanız sırasında,
          sözlü, yazılı veya elektronik ortamda olmak üzere; <br />

          <b>İnternet sitemiz üzerinden sipariş veren müşterimizseniz;</b>
          İnternet sitemizi ziyaretiniz sırasında ürün seçmeniz ve satış
          işlemlerini gerçekleştirmek amacıyla doldurmuş olduğunuz bilgiler
          vasıtasıyla elektronik yollarla toplamakta, internet ve çeşitli sosyal
          medya mecralarında Vivense adına işletilen sosyal medya hesaplarımız
          üzerinden, e-posta, kısa mesajlar (“SMS”) veya multimedya mesajları
          (“MMS”) dahil sair iletişim yöntemleri kanalıyla, onay vermeniz
          halinde Vivense satış ve pazarlama faaliyetleri kapsamında veya
          ürün/hizmetin tarafınıza sağlanması için fatura, sözleşme gibi gerekli
          belgelerin şahsınızla düzenlenmesi veya müşteri memnuniyeti ve reklam
          ve pazarlama amaçlı faaliyetlerimizi gerçekleştirmemiz sırasında,
          talep-şikayet ve önerilerinizi tarafımızla paylaşmanız sırasında,
          sözlü, yazılı veya elektronik ortamda olmak üzere; toplanmaktadır.
        </div>

        <div class="sub-title">
          5. Kişisel Verilerin Güvenliği Nasıl Sağlanmaktadır?
        </div>
        <div class="entrance-text">
          Vivense, Kişisel Verilerin gizliliğini ve güvenliğini korumaya oldukça
          önem verir. Bu kapsamda Kişisel Verileri yetkisiz erişim, zarar, kayıp
          veya ifşaya karşı korumak için gerekli teknik ve idari güvenlik
          önlemleri alınır. Bu doğrultuda gerekli sistemsel kontrolleri, veri
          erişim kontrolleri, güvenlik transfer kontrolleri, iş sürekliliği
          kontrolleri ve diğer gerekli kurumsal kontroller uygulanır.<br />

          Müşterilerimiz, kişisel veri güvenliğine ilişkin alınan tedbirlere
          dair detaylı düzenlemelere Şirketimizin
          https://www.vivense.com/kvkk-politikasi.html adresinde yayınlanan
          “Kişisel Verilerin Korunması Politikası’ndan ulaşabilecektir.<br />
          Ayrıca yukarıda belirtilen kişisel verileriniz 6098 sayılı Türk
          Borçlar Kanunu, 6502 sayılı Tüketicinin Korunması Hakkında Kanun, 6102
          sayılı Türk Ticaret Kanunu ile sayılan kanunlara ilişkin ikinci
          mevzuat hükümleri, vergi mevzuatından doğan yükümlülükler ile diğer
          yetkili kamu otoritelerinin zorunlu kıldığı haller ve sair mevzuat
          hükümleri çerçevesinde işlenebilecek olup, Vivense’ye ait fiziki
          arşivler ve bilişim sistemlerine nakledilerek, hem dijital ortamda hem
          de fiziki ortamda muhafaza altında tutulabilecektir.
        </div>
        <div class="sub-title">
          6. Kişisel Verilerinizi 3. kişilere ve/veya yurtdışına aktarıyor
          muyuz?
        </div>
        <div class="entrance-text">
          Vivense olarak Kişisel Verilerinizin güvenli bir şekilde muhafaza
          edileceğini ve hukuka aykırı bir şekilde işlenmeyeceğini taahhüt
          etmekteyiz.<br />
          Yine yukarıda belirttiğimiz hukuki sebeplerin varlığı halinde, Kişisel
          Verilerinizi, yurt içinde iş birliği yaptığımız ve/veya hizmet
          aldığımız iş bağlantıları, İlgili Bakanlıklar dahil resmi merciler,
          denetleyici ve düzenleyici kamu kurum ve kuruluşlar, tüketici hakem
          heyeti, İleti Yönetim Sistemi Anonim Şirketi, bankalar, avukatlar,
          danışmanlar dahil hizmetlerinden faydalandığımız iş ortakları ve iş
          birliği içerisinde bulunduğumuz firmalara aktarabilmekteyiz.
        </div>
        <div class="sub-title">
          7. İlgili Kişinin Hakları Olarak Haklarınız Nedir ve Başvuru Usulü
          nasıldır?
        </div>
        <div class="sub-title">i.Kişisel Verilerinize İlişkin Haklarınız</div>
        <div class="entrance-text">
          Vivense bünyesinde işlenmekte olan verilerinize ilişkin olarak aşağıda
          sayılan haklarınızın bulunduğunu belirtmek isteriz:
          <ul class="discover-list">
            <li>Kişisel Verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>
              Kişisel Verileriniz işleniyorsa bunlara ilişkin bilgi edinme,
            </li>
            <li>
              Kişisel Verilerinizin işlenme amacının ne olduğu ve kişisel
              verilerinizin amacına uygun olarak kullanılıp kullanılmadığını
              öğrenme,
            </li>
            <li>
              Varsa yurtiçinde verilerin aktarıldığı üçüncü kişilerin kimler
              olduğunu ve hangi verilerin aktarıldığını öğrenme,
            </li>
            <li>
              İşlenen Kişisel Verilerin eksik veya yanlış olması halinde
              bunların düzeltilmesini isteme,
            </li>
            <li>
              Kişisel verilerinizin düzeltilmesi, silinmesi ya da yok edilmesi
              halinde bu işlemlerin Kişisel Verilerinizin aktarıldığı üçüncü
              kişilere bildirilmesini isteme,
            </li>
            <li>
              Kişisel Verilerinizin işlenmesini gerektiren sebeplerin ortadan
              kalkması veya Kişisel Verilerinizin güncelliğini kaybetmesi
              halinde, işlenmiş olunan Kişisel Verilerinizin silinmesini veya
              yok edilmesini isteme,
            </li>
            <li>
              İşlenen Kişisel Verilerinizin münhasıran otomatik sistemler
              vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun
              ortaya çıkmasına itiraz etme,
            </li>
            <li>
              Kişisel Verilerinizin kanuna aykırı olarak işlenmesi sebebiyle
              zarara uğramanız halinde zararın giderilmesini talep etme
              haklarına sahipsiniz.
            </li>
            Bu haklarınıza ilişkin taleplerinizi aşağıda yer alan başvuru
            usulleri ile bize iletebilirsiniz.
          </ul>
        </div>
        <div class="sub-title">ii.Başvuru</div>
        <div class="entrance-text">
          Kişisel Verilerinize ilişkin taleplerinizi, internet sitemizde yer
          alan başvuru formunu doldurup yazılı olarak son bölümde belirtilen
          adrese elden teslimat, posta veya kargo ya da noter kanalıyla, güvenli
          elektronik imza ve mobil imza ile kayıtlı elektronik posta (KEP)
          adresimize veya tarafımıza daha önce bildirdiğiniz ve sistemimizde
          kayıtlı olan elektronik posta adresiniz üzerinden
          &nbsp;kvkk@vivense.com e-posta adresi aracılılığıyla başvurmak
          suretiyle Şirketimize iletebilirsiniz. <br />
          Vivense kendisine yöneltilen talepleri, talebin niteliğine göre en
          kısa sürede ve en geç otuz gün içerisinde ücretsiz olarak
          sonuçlandıracaktır. Taleplerinizin yerine getirilmesi sebebiyle bir
          maliyet doğması hâlinde yalnızca Kurul tarafından belirlenen
          tarifedeki ücretleri sizden talep edebiliriz. <br />
          Vivense’ye yöneltilen talepler sonucunda, talepleri kabul edebilir
          veya gerekçesini açıklamak suretiyle reddedebilir ve bu cevabı yazılı
          olarak veya elektronik ortamda talepte bulunan kişiye iletebiliriz.
          Talebin kabul edilmesi halinde, Vivense olarak derhal talebin gereğini
          yerine getirmekle yükümlüyüz
        </div>
        <div class="sub-title">iii.Şikâyet</div>
        <div class="entrance-text">
          Vivense’ye yöneltmiş olduğunuz taleplerin Vivense tarafından
          reddedilmesi, Vivense tarafından verilen cevaptan memnun kalmamanız
          veya cevap verilmemesi halinde, cevabın tarafınıza bildirildiği
          tarihten itibaren 30 gün ve cevap verilmemesi halinde 30 günlük
          sürenin sonundan itibaren 30 gün içerisinde Kişisel Verileri Koruma
          Kurulu’na şikâyette bulunabilirsiniz.
        </div>
        <div class="sub-title">iv.Veri Sorumlusu Kimlik Bilgileri</div>
        <div class="entrance-text">
          İşbu metinde kullanılan Vivense ifadesi Türkiye’de kurulu ve aşağıda
          bilgileri verilen Vivense Teknoloji Hizmetleri ve Ticaret Anonim
          Şirketi için düzenlenmiş ve aşağıda belirtilen şirketin veri sorumlusu
          olduğu verilerin ilgili kişilerine hitaben düzenlenmiştir:
          <table class="table-kisisel-veri">
            <tbody>
              <tr>
                <td>
                  <b> VİVENSE TEKNOLOJİ HİZMETLERİ VE TİCARET ANONİM ŞİRKETİ </b
                  ><br />
                  <b>MERSİS NO:</b> 0925045798800018<br />
                  <b>Adres:</b> Esentepe Mah. Büyükdere Cad. Astoria Sit.
                  No:127/40 Şişli / İstanbul<br />
                  <b>KEP Adresi:</b> vivense@hs03.kep.tr<br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="policy">
      <h3 class="policy__title">Ticari Elektronik İleti İzni</h3>
      <div class="policy__content">
        'Bu formu doldurup onaylayarak Vivense Teknoloji Hizmetleri ve Ticaret
        Anonim Şirketi (“Vivense” olarak anılacaktır.) reklam, ilan, kampanya ve
        benzer faaliyetler hakkında tarafıma bilgilendirme yapılmasına ve
        tarafıma bu bağlamda ticari elektronik ileti gönderilmesine (telefon,
        sms, mms, e-posta veya diğer şekillerde) 6563 Sayılı Kanun uyarınca onay
        verdiğimi kabul ve beyan ederim. Verdiğim onayı iptal etmek istersem, bu
        durumu Vivense’nin iletişim kanallarından biri aracılığıyla Vivense’yi
        bildirebileceğim konusunda detaylı bir şekilde bilgilendirildiğimi kabul
        ve beyan ederim. Ayrıca yukarıda belirtilen hususlara ilişkin olarak
        6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca,
        Vivense’ye bildirdiğim her türlü kişisel bilginin Vivense tarafından
        işlenmesine ve aktarılmasına ilişkin Vivense Kişisel Verilerin Korunması
        Hakkında Aydınlatma Metni’ni okuduğumu, kişisel verilerimin işbu
        bilgilendirmede açıklandığı şekilde tarafıma hizmet sunulması, ürünlere
        bağlılık süreçleri kapsamında tarafıma gerekli bilgilendirmelerin
        yapılması, ürün pazarlama süreçleri kapsamında tarafıma ulaşılması,
        müşteri ilişkileri yönetimi, reklam/kampanya/promosyon süreçlerinin
        yürütülmesi ve bu kapsamda elektronik ticari iletilerin gönderilmesi,
        tarafıma daha iyi hizmet sunabilmek adına gerekli görülen işlemlerde
        kullanılması amacıyla tamamen veya kısmen kaydedilmesi, depolanması,
        muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması,
        yurt içi veya yurtdışına aktarılması, devralınması, elde edilebilir hâle
        getirilmesi, mevzuat hükümlerinin izin verdiği ya da zorunlu tuttuğu
        kişi veya kuruluşlarla, resmi mercilerin talepleri üzerine resmi
        mercilerle ve yurtiçi/yurtdışı faaliyetlerinizi yürütmek üzere hizmet
        aldığınız, yurtiçi/yurtdışı işbirliği yaptığımız kuruluşlar, anlaşmalı
        olduğunuz kargo şirketi ve 3. kişilerle paylaşılması, sınıflandırılması
        ya da kullanılmasının engellenmesi gibi veriler üzerinde
        gerçekleştirilen her türlü işlemi yapması için Vivense Teknoloji
        Hizmetleri ve Ticaret Anonim Şirketi’ne açıkça onay verdiğimi, kişisel
        verilerime ilişkin haklarımın olduğu hususunda bilgilendirildiğimi kabul
        ve beyan ederim.'
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyContents',
};
</script>
